import {Component, inject, input, viewChild} from '@angular/core';
import {Router} from '@angular/router';
import {Button} from 'primeng/button';
import {Menu} from 'primeng/menu';
import {MenuItem} from 'primeng/api';
import {translate} from '@jsverse/transloco';
import {ProjectStepStateService} from '../../../pages/customer/project-sequence/project-step-state.service';
import {ProjectRoleAccessDirective} from '../../directives/project-role-access.directive';
import {ProjectRoleConfigService} from '../../services/project-role-config.service';
import {SPECIAL_OPTION_IDS} from '../../../pages/customer/project-sequence/project-step-state.constants';
import {APP_ROUTES} from '../../../app.routes';
import {ProjectRoleType, ProjectStepType} from '@frontend/shared-api';

@Component({
  selector: 'app-step-dot-menu',
  imports: [Button, Menu, ProjectRoleAccessDirective],
  templateUrl: './step-dot-menu.component.html',
})
export class StepDotMenuComponent {
  readonly dotMenu = viewChild.required<Menu>('dotMenu');

  projectId = input.required<number>();
  testId = input<string>('step-dot-menu-button');
  preselectedRole = input<ProjectRoleType>();
  preselectedAccessiblePages = input<ProjectStepType[]>();

  private readonly router = inject(Router);
  private readonly stepStateService = inject(ProjectStepStateService);
  private readonly roleConfigService = inject(ProjectRoleConfigService);

  protected readonly projectManagerConfig =
    this.roleConfigService.createProjectManagerOnlyConfigSignal(this.projectId);

  onDotMenuClick(event: MouseEvent) {
    const dotMenu = this.dotMenu();
    dotMenu.model = this.getMenuItems();
    dotMenu.toggle(event);
  }

  private getMenuItems(): MenuItem[] {
    return [
      {
        label: translate('dotMenu.addContributor'),
        icon: 'pi pi-user-plus',
        command: () => this.navigateToUserManagementWithAddDialog(),
      },
    ];
  }

  private navigateToUserManagementWithAddDialog() {
    const queryParams: {
      openAddDialog: string;
      preselectedRole?: string;
      preselectedPages?: string;
    } = {
      openAddDialog: 'true',
    };

    const role = this.preselectedRole();
    if (role) {
      queryParams.preselectedRole = role;
    }

    const pages = this.preselectedAccessiblePages();
    if (pages && pages.length > 0) {
      queryParams.preselectedPages = JSON.stringify(pages);
    }

    this.router.navigate([APP_ROUTES.PROJECT, this.projectId(), APP_ROUTES.STEPS], {
      queryParams,
    });
    this.stepStateService.setActiveSpecialOption(SPECIAL_OPTION_IDS.USER_MANAGEMENT);
  }
}
